webpackJsonp([12],{

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Officce_vue__ = __webpack_require__(376);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaee9854_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Officce_vue__ = __webpack_require__(466);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Officce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaee9854_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Officce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
module.exports = __webpack_require__(3).Object.assign;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(183) });


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(5);
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(184);
var pIE = __webpack_require__(185);
var toObject = __webpack_require__(65);
var IObject = __webpack_require__(64);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 184:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var OfficceService = function () {
  function OfficceService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OfficceService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OfficceService, null, [{
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var officces;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "offices");

              case 3:
                officces = _context.sent;
                return _context.abrupt('return', officces.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getByName',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(description) {
        var officces;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + ('offices/' + description));

              case 3:
                officces = _context2.sent;
                return _context2.abrupt('return', officces.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getByName(_x) {
        return _ref2.apply(this, arguments);
      }

      return getByName;
    }()
  }, {
    key: 'save',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(officce) {
        var officceSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "offices", officce);

              case 3:
                officceSaved = _context3.sent;
                return _context3.abrupt('return', officceSaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function save(_x2) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(officce) {
        var officceUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + "offices", officce);

              case 3:
                officceUpdated = _context4.sent;
                return _context4.abrupt('return', officceUpdated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x3) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(officce) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url + "offices", {
                  data: officce
                });

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function remove(_x4) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return OfficceService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (OfficceService);

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_OfficceService__ = __webpack_require__(205);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {
      alert: false,
      msgAlert: "",
      title: "Listagem de Serviços",
      footerText: "Total de registos: ",
      emptyRecordsText: "Nenhum registro encontrado",
      loadingRecordsText: "Carregando registros...",
      loading: false,
      dialog: false,
      dialogRemove: false,
      confirmedExclusion: false,
      isEditing: false,
      officceRemove: {},
      officceEdit: {},
      officces: [],
      officce: {},
      /**********\
      ***Rules***
      \**********/
      inputRules: [function (v) {
        return !!v || 'Campo obrigatório';
      }],
      headers: [{
        text: "Descrição",
        align: "center",
        value: "description",
        sortable: true
      }, {
        text: "",
        align: "center",
        value: "description",
        sortable: false
      }]
    };
  },

  computed: {
    formTitle: function formTitle() {
      return this.isEditing ? "Editar Serviço" : "Criar Serviço";
    },
    dynamicFooterText: function dynamicFooterText() {
      var text = "" + (this.loading ? this.loadingRecordsText : this.emptyRecordsText);
      return text;
    },
    calculatedRecords: function calculatedRecords() {
      var amount = 0;
      for (var i = 0; i < this.officces.length; i++) {
        amount++;
      }
      return amount;
    }
  },

  watch: {
    dialog: function dialog(val) {
      val || this.initialize();
    }
  },

  created: function created() {
    this.initialize();
  },


  methods: {
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__service_OfficceService__["a" /* default */].getAll();

              case 4:
                _this.officces = _context.sent;

                _this.isEditing = false;
                _this.dialog = false;
                _this.dialogRemove = false;
                _this.officce = {};
                _this.officceEdit = {};
                _this.officceRemove = {};
                _this.confirmedExclusion = false;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 17:
                _context.prev = 17;

                _this.loading = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 14, 17, 20]]);
      }))();
    },
    edit: function edit(officceEditing) {
      //this.officceEdit = officceEditing;
      this.officceEdit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, officceEditing);
      this.isEditing = true;
      this.disabledButtonSave = false;
      this.dialog = true;
    },
    remove: function remove() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__service_OfficceService__["a" /* default */].remove(_this2.officceRemove);

              case 4:
                _this2.initialize();
                _this2.msgAlert = "Excluído com sucesso";
                _this2.alert = true;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);

                console.log(_context2.t0);

              case 12:
                _context2.prev = 12;

                _this2.loading = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9, 12, 15]]);
      }))();
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.$refs.form.validate()) {
                  _context3.next = 23;
                  break;
                }

                _this3.loading = true;
                _context3.prev = 2;

                _this3.officce = _this3.officceEdit;

                if (!_this3.isEditing) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__service_OfficceService__["a" /* default */].update(_this3.officce);

              case 7:
                _this3.msgAlert = "Alterado com sucesso";
                _this3.alert = true;
                _context3.next = 15;
                break;

              case 11:
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_3__service_OfficceService__["a" /* default */].save(_this3.officce);

              case 13:
                _this3.msgAlert = "Salvo com sucesso";
                _this3.alert = true;

              case 15:
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](2);

                console.log(_context3.t0);

              case 20:
                _context3.prev = 20;

                _this3.initialize();
                return _context3.finish(20);

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 17, 20, 23]]);
      }))();
    },
    // save()
    resetForm: function resetForm() {
      this.$refs.form.reset();
      this.initialize();
    }
  }

});

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(465);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("b4503d62", content, true, {});

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Officce.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"transition":"slide-y-transition"},on:{"click":function($event){_vm.alert = false; _vm.msgAlert='';}}},[_c('v-alert',{attrs:{"transition":"slide-y-transition","dismissible":"","outline":"","type":"warning"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n      "+_vm._s(_vm.msgAlert)+"\n    ")])],1),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light headline"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.loading,"loading":_vm.loading,"color":"info","round":"","icon":"","title":"Inserir um novo serviço"},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-card',[_c('v-toolbar',{staticClass:"elevation-3",attrs:{"color":"white"}},[_c('v-toolbar-items',[_c('v-btn',{attrs:{"title":"Cancelar","color":"error","icon":"","round":"","flat":""},on:{"click":function($event){return _vm.resetForm()}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("remove")])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"font-weight-light headline"},[_vm._v(_vm._s(_vm.formTitle))])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.inputRules,"label":"Descrição","autofocus":""},model:{value:(_vm.officceEdit.description),callback:function ($$v) {_vm.$set(_vm.officceEdit, "description", $$v)},expression:"officceEdit.description"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"success lighten-1","block":"","round":""},on:{"click":function($event){return _vm.save();}}},[_vm._v("Salvar\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"rows-per-page-text":"Colunas por página","loading":_vm.loading,"headers":_vm.headers,"items":_vm.officces},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0 text-xs-center"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"title":"Editar registro","color":"info","flat":"","icon":"","round":""},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"title":"Excluir registro","color":"error","flat":"","icon":"","round":""},on:{"click":function($event){_vm.officceRemove = props.item; _vm.dialogRemove = true;}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n      Linhas "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),(_vm.calculatedRecords > 0)?_c('template',{slot:"footer"},[_c('td',{attrs:{"colspan":"100%"}},[_c('strong',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.footerText)+" "+_vm._s(_vm.calculatedRecords)+" ")])])]):_c('template',{slot:"no-data"},[_c('strong',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.dynamicFooterText)+" ")])])],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialogRemove),callback:function ($$v) {_vm.dialogRemove=$$v},expression:"dialogRemove"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Excluir Registro")]),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v("Descrição: "+_vm._s(_vm.officceRemove.description))])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){return _vm.remove();}}},[_vm._v("\n            Sim\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogRemove = false}}},[_vm._v("\n            Não\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.3ac51ef4ef31d2c99ef2.js